import { Paper, Typography } from "@mui/material";
import { usePushConnectorRouteParamListener } from "../../../hook/pushConnector";
import { usePushConnectorForm } from "../../../hook/pushConnector/edit";
import { PushConnectorFormField } from "../../../types/pushConnector";
import { PushConnectorFormFields } from "./components";

const R = require("ramda");

export const PushConnectorEditPage: React.FC = () => {
  usePushConnectorRouteParamListener();
  const [pushConnectorForm, setPushConnector] = usePushConnectorForm();
  const nameField: PushConnectorFormField = R.find(
    R.compose(R.equals("name"), R.prop("label")),
    pushConnectorForm
  );
  const name = nameField.value;

  return (
    <Paper
      sx={{ padding: 3, gap: 3, display: "flex", flexDirection: "column" }}
    >
      <Typography variant="h3">{name}</Typography>
      <PushConnectorFormFields pushConnectorForm={pushConnectorForm} />
    </Paper>
  );
};
